import "swiper/css/effect-fade";
import "swiper/css/free-mode";
import "swiper/css/grid";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css";
import "react-modal-video/css/modal-video.css";
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";
import "./assets/css/common.css";
import "rsuite/dist/rsuite.min.css";
import "./assets/other/switcher/switcher.css";
import "./assets/css/style.css";

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import ScrollTop from "./constent/ScrollTop";
import AboutUs from "./pages/AboutUs";
import Faq from "./pages/Faq";

import ComingSoon from "./pages/ComingSoon";
// import Account from "./pages/Account";
import MenuStyle4 from "./pages/MenuStyle4";

import ShopCheckout from "./pages/ShopCheckout";
import ContactUs from "./pages/ContactUs";
import OnlineOrder from "./pages/OnlineOrder";
import { useDispatch, useSelector } from "react-redux";
import { getRestaurantThunk } from "./store/restaurants";
import Home2 from "./pages/Home2";
import { useContext, useEffect } from "react";
import Order from "./pages/Order";
import { checkIfLunchTime } from "./Utilts/helper";
import { Context } from "./context/AppContext";


function App() {
  const dispatch = useDispatch()
  const restaurant = useSelector((state) => state.restaurant.restaurant);
  const { restaurantId} = useContext(Context)

  useEffect(() => {

    dispatch(getRestaurantThunk(restaurantId));
  }, [dispatch]); 


  return (
    <>
      <div className="page-wraper">
        <Router>
          {/* <SignIn /> */}
          <ScrollTop />
        
          <Routes>
              <Route exact path="/" element={<Home2 restaurant={restaurant} />} />
              <Route path="/online-order" element={<OnlineOrder restaurant={restaurant}/>} />
              <Route path="/menu" element={<MenuStyle4 restaurant={restaurant}/>} />

              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/faq" element={<Faq />} />

              <Route path="/checkout" element={<ShopCheckout />} />

              <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/order-confirmed/:tip/:name/:phone/:coupon/:address" element={<ComingSoon />} />
            <Route path='/order/:id/:restaurant_id' element={<Order />} />
            {/* <Route path="/account" element={<Account />} /> */}
            </Routes>
            
          {/* <Switcher />// */}
        </Router>
      </div>
    </>
  );
}

export default App;
